<template>
  <div class="author-tag">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-3">
          <div class="form-group">
            <label for>
              Margem do topo
              <span class="required-field">*</span>
            </label>
            <input type="number" v-model="tagObs.margin_top" class="form-control" />
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label for>
              Margem do rodapé
              <span class="required-field">*</span>
            </label>
            <input type="number" v-model="tagObs.margin_bottom" class="form-control" />
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label for>
              Margem do esquerda
              <span class="required-field">*</span>
            </label>
            <input type="number" v-model="tagObs.margin_left" class="form-control" />
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label for>
              Margem do direita
              <span class="required-field">*</span>
            </label>
            <input type="number" v-model="tagObs.margin_right" class="form-control" />
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label for>
              Margem do meio
              <span class="required-field">*</span>
            </label>
            <input type="number" v-model="tagObs.margin_center" class="form-control" />
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label for>
              Largura da etiqueta
              <span class="required-field">*</span>
            </label>
            <input type="number" v-model="tagObs.width" class="form-control" />
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label for>
              Altura da etiqueta
              <span class="required-field">*</span>
            </label>
            <input type="number" v-model="tagObs.height" class="form-control" />
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label for>
              Qtd. por folha
              <span class="required-field">*</span>
            </label>
            <input type="number" v-model="tagObs.quantity" class="form-control" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "author-letter",
  props: {
    data: Object
  },
  data() {
    return {
      tagObs: {}
    };
  },
  mounted() {
    this.tagObs = JSON.parse(this.data.value);
  },
  computed: {
    tag: {
      get() {
        return JSON.parse(this.data.value);
      },
      set(val) {
        this.$emit("updateContentComponent", JSON.stringify(val));
      }
    }
  },
  watch: {
    tagObs: {
      handler: function(value) {
        this.tag = this.tagObs;
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
.author-tag {
  .container-fluid {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>